export const staircaseConfig = {
    gameSlug: 'word-pyramids',
    category: 'foudre_logique',
    variable: 'n_items',
    startValue: 5,
    minValue: 4,
    maxValue: 9,
    stepSizesByPhase: [1, 1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** Bloc court — chaque trial = 1 round 90s ; on ne dépasse jamais 8. */
    maxTrials: 8,
    direction: 'up-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            roundMs: 90_000,
            targetMultiplier: 1.5,
            bilingual: false,
            label: 'Lettres simples',
        };
    }
    if (level <= 20) {
        return {
            level,
            roundMs: 90_000,
            targetMultiplier: 2.0,
            bilingual: false,
            label: 'Lexical fluide',
        };
    }
    if (level <= 30) {
        return {
            level,
            roundMs: 75_000,
            targetMultiplier: 2.0,
            bilingual: false,
            label: 'Anagrammes denses',
        };
    }
    if (level <= 40) {
        return {
            level,
            roundMs: 60_000,
            targetMultiplier: 2.5,
            bilingual: false,
            label: 'Pression temporelle',
        };
    }
    return {
        level,
        roundMs: 60_000,
        targetMultiplier: 2.5,
        bilingual: true,
        label: 'Bilingue FR/EN',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 500,
    feedbackMs: 1500,
    itiMs: 1000,
};
export const paradigmMeta = {
    slug: 'word-pyramids',
    paradigm: 'Anagram / verbal fluency (Bowden 1997, Shao 2014)',
    /** Internal only — non affiché. */
    masterMage: 'Volta · Ondine',
    category: 'foudre_logique',
    goal: "Compose le maximum de mots valides à partir des lettres données.",
};
//# sourceMappingURL=params.js.map